import { render, staticRenderFns } from "./TanggalPerolehan.vue?vue&type=template&id=7d6747c2&"
import script from "./TanggalPerolehan.vue?vue&type=script&lang=js&"
export * from "./TanggalPerolehan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports